export const Eyebrow = () => {
  return <div className="bg-primary my-2 h-1 w-[4.1875rem]"></div>
}
